import { NEAR_BLACK, DINGY_GRAY, NEAR_WHITE } from "@shape/reef-shared";
import styled from "styled-components";

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  color: ${NEAR_WHITE};
  font-size: 14px;
  background: ${NEAR_BLACK};
  border: 1px solid ${DINGY_GRAY};
  border-radius: 6px;
  width: 200px;
  max-height: 300px;
  transform-origin: top right;
  animation: openMenu 0.1s ease-out;
  position: absolute;
  top: 100%;
  right: 0;

  strong {
    margin-left: 8px;
    margin-top: 8px;
  }
`;

export const MenuOptions = styled.div`
  display: flex;
  flex-direction: column;

  div {
    padding: 8px 16px;
    cursor: pointer;
    transition: 0.2s ease;
    outline: none;

    &:hover,
    &:focus {
      background-color: rgba(255, 255, 255, 0.08);
    }
  }
`;
